export default {
  titles: {
    site: 'Deal Analyzer',
    pages: {
      dashboard: 'Dashboard',
      dealDuplicate: 'Duplicate Deal',
      dealList: 'Deals',
      dealDetail: 'Deal Detail',
      dealCreate: 'New Deal',
      formulaList: 'Formulas',
      help: 'Help',
      markerList: 'Markers',
      oops: 'Not Found',
      unauthorized: 'Unauthorized Access',
    },
    modals: {
      deleteDeal: 'Delete Deal',
      duplicateDeal: 'Duplicate Deal',
      shareDeal: 'Share Deal',
      changeDealStatus: 'Change offer status',
      confirm: 'Confirm',
      save: 'Save your changes?',
    },
  },
  alt: {
    loader: 'Loading spinner',
    closeModal: 'Close modal',
  },
  button: {
    cancel: 'Cancel',
    close: 'Close',
    compare: 'Compare',
    delete: 'Delete',
    deleteConfirmation: 'Yes, delete',
    duplicate: 'Duplicate',
    saveDealConfirmation: 'Yes, save deal',
    share: 'Share',
    updateStatus: 'Update status',
    save: 'Save',
    dontsave: "Don't Save",
  },
  header: {
    feedback: 'Feedback',
    help: 'Help',
    pricingToolKit: 'Pricing ToolKit',
    reportAnIssue: 'Report an issue',
    bookmark: 'My Bookmarks',
    whatsNew: "What's New",
    salesforce: '4C',
  },
  tooltip: {
    dealStatus:
      'Select 4C Contract as Final Deal into 4C.\nBest Alternative to Negotiated Agreement.\nCurrent as Existing Contract with customers.\nPlan as Business Plan.\nTarget as Mandate Target.\nWalkaway as Mandate Walkaway.',
  },
  general: {
    cancel: 'Cancel',
    no: 'No',
    notApplicable: 'N/A',
    yes: 'Yes',
    ellipsis: '...',
  },
  currency: {
    dollar: '$',
    cents: '¢',
    dollarsPerTon: '$/T',
    centsPerPound: '¢/LB',
  },
  volume: {
    ton: 'T',
    pound: 'LB',
  },
  comparisonLimit: 10,
};
